import styled from '@emotion/styled/macro';
import { BaseButton, Card, forPhoneOnly, Spinner, Variables } from '@enter/core';

interface ICell {
    nowrap?: boolean;
    align?: 'left' | 'right' | 'center';
}

export const GuarantorOverviewCard = styled(Card)`
    display: flex;
    flex-direction: column;
    padding: 24px;
    flex: 0;
`;

export const Title = styled.div`
    font-size: 15px;
    font-weight: 500;
    text-transform: uppercase;
    color: ${Variables.Colors.p500};

    ${forPhoneOnly(`
        font-size: 13px;
    `)}
`;

export const WaitSpinner = styled(Spinner)`
    svg {
        fill: white;
        stroke: ${Variables.Colors.n15};
    }
`;

export const Loader = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const Body = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-grow: 1;
    justify-content: space-around;
`;

export const Table = styled.table`
    flex: 1 1 30%;
    margin-top: 16px;
    margin-bottom: 16px;
`;

export const TH = styled.th<ICell>`
    font-size: 15px;
    font-weight: 500;
    color: ${Variables.Colors.n100};
    white-space: ${(props): string => (props.nowrap ? 'nowrap' : 'normal')};
    text-align: ${(props): string => props.align || 'left'};
    line-height: 1.2;
    padding: 0px 8px;

    ${forPhoneOnly(`
        font-size: 13px;
    `)}
`;

export const TD = styled.td<ICell>`
    font-size: 15px;
    line-height: 18px;
    white-space: ${(props): string => (props.nowrap ? 'nowrap' : 'normal')};
    text-align: ${(props): string => props.align || 'left'};
    padding-left: 8px;
    color: ${Variables.Colors.n70};

    ${forPhoneOnly(`
        font-size: 13px;
    `)}
`;

export const NoResults = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${Variables.Colors.n100};
`;

export const StyledButton = styled(BaseButton)`
    &:not(:first-of-type) {
        margin-left: 8px;
    }
`;
